<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="user !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.user.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
          <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'gender'" [control]="form.get('gender')" [type]="'select'" [options]="salutations" [label]="t('common.labels.salutation')" [edit]="inEdit" [basevalue]="t(user.getSalutation())"></app-form-control>
        <app-form-control [cid]="'firstname'" [control]="form.get('firstname')" [type]="'input'" [label]="t('common.labels.firstname')" [edit]="inEdit" [basevalue]="user.firstname"></app-form-control>
        <app-form-control [cid]="'lastname'" [control]="form.get('lastname')" [type]="'input'" [label]="t('common.labels.lastname')" [edit]="inEdit" [basevalue]="user.lastname"></app-form-control>
        <app-form-control [cid]="'team'" [control]="form.get('team')" [type]="'select'" [label]="t('common.labels.team')" [options]="teams" [optionLabel]="'name'" [edit]="inEdit" [basevalue]="user.team_name" [showClear]="true"></app-form-control>
        <app-form-control [cid]="'company'" [control]="form.get('company')" [type]="'input'" [label]="t('common.labels.company')" [edit]="inEdit" [basevalue]="user.company"></app-form-control>
        <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [options]="languages" [label]="t('common.labels.language')" [edit]="inEdit" [basevalue]="t(user.getLanguageName())"></app-form-control>

      </div>
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'email'" [control]="form.get('email')" [type]="'input'" [label]="t('common.labels.email')" [edit]="inEdit" [basevalue]="user.email"></app-form-control>
        <app-form-control [cid]="'phone'" [control]="form.get('phone')" [type]="'input'" [label]="t('common.labels.phone')" [edit]="inEdit" [basevalue]="user.phone"></app-form-control>
        <app-form-control [cid]="'mobile'" [control]="form.get('mobile')" [type]="'input'" [label]="t('common.labels.mobile')" [edit]="inEdit" [basevalue]="user.mobile"></app-form-control>
        <app-country-timezone [edit]="inEdit" [required]="true" [(country)]="country" [(timezone)]="timezone" [form]="this.form.get('tz')"></app-country-timezone>

      </div>
    </div>

    <hr>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'comment'" [control]="form.get('comment')" [type]="'textarea'" [label]="t('common.labels.comment')" [edit]="inEdit" [basevalue]="user.comment"></app-form-control>
      </div>
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'alt_emails'" [control]="form.get('alt_emails')" [type]="'textarea'" [label]="t('common.labels.alternative_email_recipients')" [info]="t('common.labels.separation_by_comma')" [edit]="inEdit" [basevalue]="user.alt_emails"></app-form-control>
      </div>
    </div>

    <hr>
    <h2>{{ t('common.labels.roles') }}</h2>

    <div class="p-grid p-fluid">
      <div class="p-col-6">
        <app-form-control [cid]="'roles'" [control]="form.get('roles')" [type]="'multiselect'" [label]="t('common.labels.roles')" [edit]="inEdit" [basevalue]="getUserRoleNames().join(', ')" [options]="roles" [optionLabel]="'translated_title'" [dataKey]="'id'"></app-form-control>
      </div>
    </div>

    <ng-container *ngIf="inEdit === true">

      <hr>
      <h2>{{ t('common.labels.password') }}</h2>

      <div class="p-grid p-fluid">
        <div class="p-col-6">
          <app-form-control *ngIf="inEdit === true" [cid]="'password'" [control]="form.get('passwords.password')" [type]="'password'" [label]="t('common.labels.password')"></app-form-control>
        </div>
        <div class="p-col-6">
          <app-form-control *ngIf="inEdit === true" [cid]="'confirm'" [control]="form.get('passwords.confirm')" [type]="'password'" [label]="t('common.labels.password_repetition')"></app-form-control>
        </div>
      </div>

    </ng-container>

  </form>
</ng-container>
